import './ProgressBar.scss';
import { LinearProgress } from '@mui/joy';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  success?: boolean;
  value: number;
  max?: number;
  enableStripesAnimation?: boolean;
}

export const ProgressBar = observer((props: IProps): ReactElement => {
  return (
    <LinearProgress
      className={classNames({ stripes: props.enableStripesAnimation, animate: props.enableStripesAnimation })}
      color={props.success === false ? 'warning' : 'primary'}
      variant='soft'
      value={Math.max(Math.min((props.value / (props.max ?? 100)) * 100, 100), 0)}
      determinate
      size='lg'
    />
  );
});
